import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { AudioData } from "./AudioData";
import { CardProgress, getColor } from "./CardProgress";
import { ImageInfo } from "./ImageInfo";

dayjs.extend(relativeTime);

export class CardData {
  front!: string;
  back!: string;
  image!: ImageInfo | null;
  interval!: number;
  repetition!: number;
  efactor!: number;
  audio?: AudioData;
  dueDate!: string;
  romanization!: string;

  getProgress(): CardProgress {
    if (this.repetition < 2) return CardProgress.New;
    const score = this.getScore();
    if (score > 8) return CardProgress.Mastered;
    if (score > 5) return CardProgress.Know;
    return CardProgress.Learned;
  }

  getProgressString() {
    const progress = this.getProgress();
    return CardProgress[progress].toLowerCase();
  }

  getProgressColor() {
return getColor(this.getProgress())
  }

  getScore(): number {
    return this.repetition * this.efactor;
  }

  getDueDate(): dayjs.Dayjs {
    return dayjs(this.dueDate);
  }

  getNextReviewDate(): dayjs.Dayjs {
    const dueDate = this.getDueDate();
    const nextReview = dueDate;
    const now = dayjs();
    const isPast = dueDate < now;
    if (isPast) {
      return now;
    } else {
      return nextReview;
    }
  }

  getTimeToNextReviewString(): string {
    const nextReview = this.getNextReviewDate();
    const result = nextReview.fromNow();
    if (result == "a few seconds ago") return "now";
    return result;
  }

  getNextReviewDateString(): string {
    return this.getNextReviewDate().toString();
  }
}
